import { PublicKey } from "@solana/web3.js";

export const SCN_MINT = new PublicKey("5oVNBeEEQvYi1cX3ir8Dx5n1P7pdxydbGF2X4TxVusJm");
export const STEP_SCNSOL_REFERRAL_ACCOUNT = new PublicKey("Dh3eCP47u1kCfJ2p46Gr6kADk1xvYnUWA1qLrDVtaehp");
